import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, X } from 'react-feather';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ 
  message, 
  type = 'info', 
  onClose,
  duration = 5000
}) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const bgColor = {
    success: 'bg-green-50 border-green-200',
    error: 'bg-red-50 border-red-200',
    info: 'bg-blue-50 border-blue-200'
  }[type];

  const textColor = {
    success: 'text-green-800',
    error: 'text-red-800',
    info: 'text-blue-800'
  }[type];

  const Icon = {
    success: CheckCircle,
    error: AlertCircle,
    info: AlertCircle
  }[type];

  return (
    <div className={`fixed bottom-4 right-4 z-50 flex items-center p-4 rounded-lg border ${bgColor} animate-slideIn`}>
      <Icon className={`w-5 h-5 ${textColor} mr-2`} />
      <p className={`text-sm ${textColor}`}>{message}</p>
      <button
        onClick={onClose}
        className={`ml-4 ${textColor} hover:opacity-75`}
        aria-label="Close"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Toast;